import { ContentFeed, ContentFeedTypeEnum } from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";
export { default } from "./EventView.vue";

export const selector = (feed: ContentFeed): boolean => {
  return feed.type === ContentFeedTypeEnum.EVENT;
};
